import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ReconnectingStatus } from '../types';

interface ReconnectingState {
    reconnecting: ReconnectingStatus;
}

const initialState: ReconnectingState = {
    reconnecting: ReconnectingStatus.Idle,
};

const reconnectingSlice = createSlice({
    name: 'reconnecting',
    initialState,
    reducers: {
        setReconnecting: (
            state,
            { payload }: PayloadAction<ReconnectingStatus>
        ) => {
            state.reconnecting = payload;
        },
    },
});

export const getReconnectingState = (state: RootState) => state.reconnecting;

export const getReconnecting = createSelector(
    [getReconnectingState],
    state => state.reconnecting
);

export const reconnectingInitialState = reconnectingSlice.getInitialState();
export const reconnectingReducer = reconnectingSlice.reducer;
export const { setReconnecting } = reconnectingSlice.actions;
